;(function ($) {
  "use strict"

  $(document).ready(function () {
    $(document).on("click", ".person-toggle", function (event) {
      event.preventDefault()

      const $this = $(this)
      const $person = $this.closest(".person-card")
      const $modal = $(".modal")
      const $modalTitle = $modal.find("h3")
      const $modalBody = $modal.find(".modal-body")

      $modalBody.addClass("person-modal")
      $modalTitle.text($person.find("h3").text())
      $modalBody.html($person.find("figure, footer").clone())
    })
  })
})(jQuery)
